


















import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { SingleAssetUsage } from '@/store/modules/asset'
import { FrameClipper } from '@/components/products/framepuzzle/util/frameClipper'
import { FramePuzzleModule } from '@/store/modules/framePuzzle'

import EventBus from '@/utils/eventBus'

type ImageData = { url: string, style: string }

@Component({
    name: 'frame-puzzle-editor-passive'
})
export default class FramePuzzleEditorPassive extends Vue {
    @Prop() private step!: number
    @Prop() private usageName!: string

    public imageClipper = FrameClipper.getCollageClipper(true, this.imageEditorWidth, this.imageEditorHeight, this.step, this.usageName)
    public puzzleImageUrl = ""

    get updatePreview() {
        return FramePuzzleModule.updatePreview
    }

    @Watch('updatePreview')
    updatePuzzleBoxChanged() {
        this.setPreviewAsset()
    }

    get hasOverlaySlot() {
        return !!this.$slots['overlay']
    }

    get imageEditorWidth() {
        return FramePuzzleModule.imageEditorWidth
    }

    get imageEditorHeight() {
        return FramePuzzleModule.imageEditorHeight
    }

    get parts() {
        return FramePuzzleModule.parts
    }

    get puzzleAsset() {
        let usageName = this.imageClipper.usageName
        if (usageName) {
            return FramePuzzleModule.activeAssets[usageName]
        }
        return undefined
    }

    get recoverPuzzleToogled() {
        return FramePuzzleModule.recoverPuzzleToggled
    }

    setPreviewAsset() {
        let asset = FramePuzzleModule.activeAssets[this.usageName]
        if (asset !== undefined) {
            let usage = asset.usage[this.usageName] as SingleAssetUsage
            if (!usage) {
                usage = asset.pendingUsage[this.usageName] as SingleAssetUsage
            }
            if (usage && asset !== undefined) {
                this.puzzleImageUrl = asset.url
                this.imageClipper.initializeUsage(usage, asset.rect)
            } else {
                this.puzzleImageUrl = ""
            }
        } else {
            this.puzzleImageUrl = ""
        }
    }

    mounted() {
       this.setPreviewAsset()
    }
}
